<template>
  <button id="CHANNEL_UP" name="CHANNEL_UP" class="btn" data-vcode="CHANNEL_UP">
    <img class="soft-img" src="/images/icn-channel-up.svg" alt="" role="img" aria-hidden="true" />
    <label>{{ $t('channelUp') }}</label>
  </button>
</template>
<script>
export default {};
</script>
